/** @prettier */

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Box,
} from '@mui/material';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';

//MTH component import
import TextFieldSelectBox from '../../component/SelectBox';
import APIErrorMessage from '../../component/APIErrorMessage';
import {PrimaryButton, SecondaryButton} from '../../component/BasicButton';
//API import
import {getDailySchedule} from '../../API/API_Collection';
//interface import
import * as apiIF from '../../Type/api';
//Style import
import '../../css/common/common.css';

import {pullDownMenu} from '../../define';

/** ファイル名用の特定日名称 */
const templateFilename = {
  'weekday-schedule': 'Weekday',
  'holiday-schedule': 'Holiday',
  'special-day-1-schedule': 'Specialday1',
  'special-day-2-schedule': 'Specialday2',
};
/**
 * 選択した特定日のスケジュールデータをダウンロードするダイアログ
 * @param props props
 * - groupID グループID
 * - isOpenDialog ダイアログ表示フラグ
 * - setIsOpenDialog ダイアログ表示フラグ 設定関数
 * - targetGroupName グループ名
 * @returns JSX
 */
const DownloadFileDialog = (props: {
  groupID: string;
  isOpenDialog: boolean;
  setIsOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
  targetGroupName: string;
}) => {
  const trans = useTranslation().t; //翻訳関数
  //パスパラメータ取得
  const {siteID} = useParams();

  /** セレクトボックスで選択したコピー元の特定日タイプ */
  const [selectTemplate, setSelectTemplate] =
    useState<keyof apiIF.res.getDailySchedule>('holiday-schedule');
  /** APIエラー時エラーメッセージ表示 */
  const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false);
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ

  /**
   * DOWNLOADボタン押下時処理
   */
  const handleClickDownload = () => {
    if (siteID === undefined) return;

    setAPIWait(true);

    getDailySchedule(siteID, props.groupID, {format: 'csv'}).then(response => {
      // 配列を文字列に変換
      const Data = response[selectTemplate].toString();
      //セレクトボックスで選択した特定日のスケジュールデータのCSVファイルを取得
      const blob = new Blob([Data], {type: 'text/csv'});
      const fileName = `current_schedule_${props.targetGroupName}_${templateFilename[selectTemplate]}`;
      let link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      setAPIWait(false);
    });
  };

  /**
   * ダイアログを閉じる処理
   */
  const handleClose = () => {
    setSelectTemplate('holiday-schedule');
    props.setIsOpenDialog(false);
    setAPIWait(false);
  };

  return (
    <>
      <Dialog
        open={props.isOpenDialog}
        onClose={handleClose}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          {trans('DownloadFileDialog.title')}
        </DialogTitle>
        <DialogContent className="schedule__copyDialog__content">
          <Stack spacing={2}>
            {/** グループの名前 */}
            <Box>{props.targetGroupName}</Box>
            {/** コピー元の特定日の種類選択欄 */}
            <Box className="schedule__copyDialog__content__specificScheduleSelectArea">
              <TextFieldSelectBox
                label={trans('DownloadFileDialog.selectBoxLabel')}
                choices={pullDownMenu.SCHEDULE_TEMPLATE}
                value={selectTemplate}
                setValue={setSelectTemplate}
                class="schedule__copyDialog__content__specificScheduleSelectArea__selectBox"
              />
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            onClick={handleClose}
            buttonText={trans('DownloadFileDialog.buttonTxt.cancel')}
          />
          <PrimaryButton
            onClick={handleClickDownload}
            buttonText={trans('DownloadFileDialog.buttonTxt.download')}
            apiWait={apiWait}
            disabled={apiWait}
          />
        </DialogActions>
      </Dialog>
      <APIErrorMessage
        open={isOpenErrorDialog}
        setOpen={setIsOpenErrorDialog}
      />
    </>
  );
};
export default DownloadFileDialog;
